import { Menu, Transition } from "@headlessui/react";
import cx from "classnames";
import { ChevronIcon, HomeIcon } from "../../atoms/Icons";
import Text from "../../atoms/Text";
import Divider from "../../atoms/Divider";
import NavLink from "./NavLink";
import * as s from "./styles";
import { transitionProps } from "./utils";
import type { NavbarProps, NavbarLink } from "./index";

type NavbarMobileProps = Pick<NavbarProps, "isOrganisationAdmin" | "labels"> & {
  mobileLinks: NavbarLink[];
  organisationAdminLinks: NavbarLink[];
  variant: "light" | "dark";
};

export default function NavbarMobile({
  isOrganisationAdmin,
  labels,
  mobileLinks,
  organisationAdminLinks,
  variant,
}: NavbarMobileProps) {
  const isDark = variant === "dark";
  return (
    <nav>
      <Menu>
        {({ open }) => (
          <>
            <Menu.Button
              className={cx(s.dropdownButton, {
                "bg-purple-900 text-white": isDark,
              })}
            >
              <HomeIcon />
              <ChevronIcon direction={open ? "up" : "down"} />
            </Menu.Button>
            <Transition
              as="div"
              className="z-100 relative"
              {...transitionProps}
            >
              <Menu.Items
                className={cx(s.dropdownItems, {
                  "!bg-purple-950 !text-white": isDark,
                })}
              >
                {mobileLinks.map((link) => (
                  <Menu.Item key={`${link.href}-${link.label}`}>
                    <NavLink {...link} variant={variant} />
                  </Menu.Item>
                ))}

                {isOrganisationAdmin && organisationAdminLinks.length > 0 && (
                  <>
                    <Divider />
                    <div className="ml-4">
                      <Text variant="label" color={isDark ? "white" : "light"}>
                        {labels.company}
                      </Text>
                    </div>

                    {organisationAdminLinks.map((link) => (
                      <Menu.Item key={`${link.href}-${link.label}`}>
                        <NavLink {...link} variant={variant} />
                      </Menu.Item>
                    ))}
                  </>
                )}
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </nav>
  );
}
